// Status-pill helper mirroring the Tessell portal `bdg(bg, fg)` token system.
// Use for small status/tier chips: <Box sx={badges(colors).deployed}>DEPLOYED</Box>
export const badge = (bg, fg) => ({
  display: "inline-flex",
  alignItems: "center",
  padding: "2px 8px",
  borderRadius: "8px",
  fontSize: 11,
  fontWeight: 500,
  lineHeight: "16px",
  backgroundColor: bg,
  color: fg,
  whiteSpace: "nowrap",
});

// Semantic pill set (bg, fg), routed through tokens(paletteId).
export const badges = (colors) => ({
  deployed: badge(colors.okBg, colors.okFg),
  deploying: badge(colors.infoBg, colors.infoFg),
  failed: badge(colors.errBg, colors.errFg),
  newItem: badge(colors.warnBg, colors.warnFg),
  inQA: badge(colors.qaBg, colors.qaFg),
  inStage: badge(colors.stageBg, colors.stageFg),
  inProd: badge(colors.prodBg, colors.prodFg),
  incubating: badge(colors.warnBg, colors.warnFg),
  neutral: badge(colors.neuBg, colors.neuFg),
  complete: badge(colors.okBg, colors.okFg),
  readyQA: badge(colors.okBg, colors.okFg),
  readyStage: badge(colors.stageBg, colors.stageFg),
  enterprise: badge(colors.qaBg, colors.qaFg),
  standard: badge(colors.neuBg, colors.neuFg),
  compliance: badge(colors.errBg, colors.errFg),
  internal: badge(colors.neuBg, colors.sec),
  hibernated: badge(colors.neuBg, colors.neuFg),
});

// Convenience aliases for common semantic intents.
export const badgeVariants = (colors) => {
  const b = badges(colors);
  return {
    success: b.deployed,
    info: b.deploying,
    danger: b.failed,
    warning: b.newItem,
    neutral: b.neutral,
  };
};
